<template>
    <v-container grid-list-md fluid class="pa-1">
        <v-row no-gutters class="py-1 px-1">
            <v-col class="pa-1" cols="12"><h3>Production</h3></v-col>

            <v-col
                v-if="isAuditCheckDocumentAnomalyCardVisible || loadingAuditCheckDocuments"
                :cols="openPointCardColSize"
                class="px-1 py-1"
            >
                <v-skeleton-loader
                    v-if="loadingAuditCheckDocuments"
                    class="mx-auto"
                    type="list-item"
                />
                <AuditCheckCard
                    v-else
                    :auditCheckItemsCount="auditCheckDocumentsWithAnomalyCount"
                    :hasBorder="true"
                    @click="onAuditCheckDocumentAnomalyCardClicked"
                    class="cursor-pointer border-sm fill-height"
                >
                </AuditCheckCard>
            </v-col>
            <v-col :cols="openPointCardColSize" class="px-1 py-1">
                <v-skeleton-loader v-if="loadingOpenPoints" class="mx-auto" type="list-item" />
                <v-row
                    v-else
                    no-gutters
                    class="pa-3 fill-height border-sm bg-white rounded-xl"
                    @click="showWaitingBT()"
                >
                    <v-col cols="12" v-if="!accountingPeriodId" class="mx-auto text-center">
                        <span>{{ noAccountingPeriodMessage }}</span>
                    </v-col>
                    <template v-else>
                        <v-col
                            cols="2"
                            class="d-flex align-center justify-center"
                            style="border-right: 1px #ededed solid"
                        >
                            <v-icon
                                :color="
                                    openPoints.waitingAccount.accountingTransactions.length
                                        ? 'red'
                                        : 'green'
                                "
                                >{{
                                    openPoints.waitingAccount.accountingTransactions.length
                                        ? "$fa-exclamation-triangle"
                                        : "$fa-check"
                                }}</v-icon
                            >
                        </v-col>
                        <v-col cols="10" class="d-flex align-center pl-2">
                            {{
                                $t(
                                    "openPoints.waitingAccount",
                                    openPoints.waitingAccount.accountingTransactions.length,
                                    {
                                        count: openPoints.waitingAccount.accountingTransactions
                                            .length,
                                    },
                                )
                            }}
                        </v-col>
                    </template>
                </v-row>
            </v-col>
            <v-col :cols="openPointCardColSize" class="px-1 py-1">
                <v-skeleton-loader v-if="loadingOpenPoints" class="mx-auto" type="list-item" />
                <v-row
                    v-else
                    no-gutters
                    class="pa-3 fill-height border-sm bg-white rounded-xl"
                    @click="showItems(openPoints.document.pendingValidation)"
                >
                    <v-col cols="12" v-if="!accountingPeriodId" class="mx-auto text-center">
                        <span>{{ noAccountingPeriodMessage }}</span>
                    </v-col>
                    <template v-else>
                        <v-col
                            cols="2"
                            class="d-flex align-center justify-center"
                            style="border-right: 1px #ededed solid"
                        >
                            <v-icon
                                :color="
                                    openPoints.document.pendingValidation.count ? 'red' : 'green'
                                "
                                >{{
                                    openPoints.document.pendingValidation.count
                                        ? "$fa-exclamation-triangle"
                                        : "$fa-check"
                                }}</v-icon
                            >
                        </v-col>
                        <v-col cols="10" class="d-flex align-center pl-2">
                            {{
                                $t(
                                    "openPoints.toValidateDocuments",
                                    openPoints.document.pendingValidation.count,
                                    { count: openPoints.document.pendingValidation.count },
                                )
                            }}
                        </v-col>
                    </template>
                </v-row>
            </v-col>
            <v-col :cols="openPointCardColSize" class="px-1 py-1">
                <v-skeleton-loader v-if="loadingOpenPoints" class="mx-auto" type="list-item" />
                <v-row
                    v-else
                    no-gutters
                    class="pa-3 fill-height border-sm bg-white rounded-xl"
                    @click="showItems(openPoints.reconciliation.pendingValidation)"
                >
                    <v-col cols="12" v-if="!accountingPeriodId" class="mx-auto text-center">
                        <span>{{ noAccountingPeriodMessage }}</span>
                    </v-col>
                    <template v-else>
                        <v-col
                            cols="2"
                            class="d-flex align-center justify-center"
                            style="border-right: 1px #ededed solid"
                        >
                            <v-icon
                                :color="
                                    openPoints.reconciliation.pendingValidation.count
                                        ? 'red'
                                        : 'green'
                                "
                                >{{
                                    openPoints.reconciliation.pendingValidation.count
                                        ? "$fa-exclamation-triangle"
                                        : "$fa-check"
                                }}</v-icon
                            >
                        </v-col>
                        <v-col cols="10" class="d-flex align-center pl-2">
                            {{
                                $t(
                                    "openPoints.toValidateReconciliations",
                                    openPoints.reconciliation.pendingValidation.count,
                                    { count: openPoints.reconciliation.pendingValidation.count },
                                )
                            }}
                        </v-col>
                    </template>
                </v-row>
            </v-col>

            <v-col cols="10" class="px-1 py-2">
                <v-skeleton-loader class="py-4" v-if="loadingProduction" type="text">
                </v-skeleton-loader>
                <v-data-table
                    v-else
                    :headers="productionHeaders"
                    :items="[company]"
                    fixed-header
                    hide-default-footer
                    calculate-widths
                    class="box-border rounded-xl table"
                    :loading="loadingProduction"
                    density="compact"
                >
                    <template v-slot:item="props">
                        <AccountingClientMonitoringProductionRow
                            :props="props"
                            :headers="productionHeaders"
                            :itemValue="productionValues"
                            :taxesMonitoring="taxesMonitoring"
                            :showFECInfo="false"
                            :hideName="true"
                            :optionsSelected="productionOptions"
                            :rowPaddingPx="4"
                        />
                        <!-- <AccountingClientMonitoringTaxesRow
                            :props="props"
                            :headers="taxesHeaders"
                            :itemValue="productionValues"
                            :taxesMonitoringItem="taxesMonitoring"
                            :showFECInfo="false"
                            :hideName="true"
                            :taxesSelected="taxOptions"
                            :useTriangleLayout="true"
                            class="pt-1"
                        /> -->
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-row no-gutters class="py-1 px-1">
            <v-col class="pa-1" cols="12"><h3>Déclarations / Clôture</h3></v-col>
            <v-col class="pa-1" cols="10">
                <v-skeleton-loader class="py-4" v-if="loadingTaxes" type="text">
                </v-skeleton-loader>
                <v-data-table
                    v-else
                    :headers="taxesHeaders"
                    :items="[company]"
                    fixed-header
                    hide-default-footer
                    calculate-widths
                    class="box-border rounded-xl table"
                    :loading="loadingTaxes"
                    :hide-default-header="false"
                    density="compact"
                >
                    <template v-slot:item="props">
                        <AccountingClientMonitoringTaxesRow
                            :props="props"
                            :headers="taxesHeaders"
                            :itemValue="productionValues"
                            :taxesMonitoringItem="taxesMonitoring"
                            :showFECInfo="false"
                            :hideName="true"
                            :taxesSelected="taxOptions"
                            :useTriangleLayout="true"
                            :rowPaddingPx="4"
                            taxType="mixed"
                        />
                    </template>
                </v-data-table>
            </v-col>
            <v-col
                cols="2"
                class="px-0 my-1 box-border"
                style="background-color: white; border-radius: 15px; overflow: hidden"
            >
                <AccountingClientMonitoringClosureRow
                    :props="{ item: company }"
                    :headers="finalizationHeaders"
                    :auditReportMonitoring="auditReportMonitoring"
                    :loading="loadingFinalization"
                    :hideName="true"
                    :layout="'horizontal'"
                />
            </v-col>
        </v-row>

        <v-row no-gutters class="py-1 px-1">
            <v-col class="pa-1" cols="12"><h3>Divers</h3></v-col>
            <v-col cols="6" class="px-1">
                <v-card
                    flat
                    outlined
                    style="border-radius: 15px"
                    :height="boxHeightInPx"
                    class="scrollbar-hidden"
                    border="sm"
                >
                    <v-row no-gutters>
                        <h4 class="pt-3 pb-1 px-2 d-inline-block">Les 10 derniers flux entrants</h4>
                        <div class="ml-auto pt-3 pb-1 px-2">
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <a v-bind="props" @click="routeToFilteredBanksPage">
                                        <v-icon size="x-small">$fa-university</v-icon>
                                        Banques
                                    </a>
                                </template>
                                <span>Ouvrir la page des dernières transactions bancaires</span>
                            </v-tooltip>
                            <span class="px-2">|</span>
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <a v-bind="props" @click="routeToFilteredDocumentsPage">
                                        <v-icon size="x-small">$fa-receipt</v-icon>
                                        Documents
                                    </a>
                                </template>
                                <span>Ouvrir la page des derniers documents</span>
                            </v-tooltip>
                        </div>
                    </v-row>
                    <v-skeleton-loader
                        type="list-item@6"
                        class="mx-2"
                        v-if="loadingBankTransactions || loadingDocuments"
                    />
                    <template v-else>
                        <v-row
                            class="no-gutters d-flex align-center justify-center"
                            style="height: 300px"
                            v-if="!incomingFlow || incomingFlow.length === 0"
                        >
                            <span class="my-auto">Aucun flux récent</span>
                        </v-row>
                        <v-table
                            v-else
                            class="scrollbar-hidden"
                            :height="flowTableHeight"
                            fixed-header
                        >
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="px-2" />
                                        <th class="px-2" />
                                        <th class="px-2">Libellé</th>
                                        <th class="px-2">Date d'ajout</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        role="button"
                                        v-for="flow of incomingFlow"
                                        :key="flow.id"
                                        @click="routeToFlowPage(flow)"
                                    >
                                        <td class="px-2">
                                            <v-icon
                                                v-if="flow.flowType === 'BankTransaction'"
                                                size="x-small"
                                                >$fa-university</v-icon
                                            >
                                            <v-icon
                                                v-else-if="flow.flowType === 'Document'"
                                                size="x-small"
                                                >$fa-receipt</v-icon
                                            >
                                        </td>
                                        <td v-if="flow.flowType === 'BankTransaction'" class="px-2">
                                            {{ flow.docType || "-" }}
                                        </td>
                                        <td v-if="flow.flowType === 'Document'" class="px-2">
                                            {{
                                                flow.docType
                                                    ? $t("document.type." + flow.docType)
                                                    : "-"
                                            }}
                                        </td>
                                        <td class="px-2">{{ flow.label }}</td>
                                        <td class="px-2">{{ flow.fCreatedAt }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-table>
                    </template>
                </v-card>
            </v-col>
            <v-col xs="6" class="px-1">
                <v-card
                    flat
                    outlined
                    :height="boxHeightInPx"
                    style="border-radius: 15px"
                    class="scrollbar-hidden"
                    border="sm"
                >
                    <v-container class="pa-0">
                        <v-row no-gutters class="sticky-top bg-white">
                            <h4 class="pt-3 pb-1 px-2 d-inline-block">Connecteurs</h4>
                            <div class="ml-auto pt-3 pb-1 px-2">
                                <v-tooltip location="bottom">
                                    <template v-slot:activator="{ props }">
                                        <v-btn-add
                                            variant="outlined"
                                            v-bind="props"
                                            @click="routeToConnectorCreationPage"
                                            size="small"
                                        >
                                        </v-btn-add>
                                    </template>
                                    <span>Ajouter un connecteur</span>
                                </v-tooltip>
                            </div>
                        </v-row>

                        <v-skeleton-loader
                            v-if="loadingConnectors || loadingConnectedBankAccounts"
                            class="mx-2"
                            type="card@2"
                        />
                        <template v-else>
                            <v-row
                                class="no-gutters d-flex align-center justify-center"
                                :style="{ height: `${connectorsEmptyMsgBoxHeight}` }"
                                v-if="!hasActiveConnections"
                            >
                                <span class="my-auto">Aucun connecteur ajouté</span>
                            </v-row>
                            <div v-else>
                                <CompanyConnectors
                                    :dense="true"
                                    :companyId="companyId"
                                    :connectorsPerLine="1"
                                    :connectors="activeConnectors"
                                    :connectedBankAccounts="connectedBankAccounts"
                                />
                            </div>
                        </template>

                        <!-- <v-row no-gutters >
                            <v-col cols="6 py-3 px-2">
                                <v-btn icon>
                                    <v-icon  size=“x-large”>$fa-plus-circle</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row> -->
                    </v-container>
                </v-card>
            </v-col>
            <v-col class="px-1">
                <v-card
                    flat
                    outlined
                    style="border-radius: 15px"
                    :height="boxHeightInPx"
                    class="scrollbar-hidden"
                    border="sm"
                >
                    <ChatCompany style="padding: 0" :height="chatMessagesBoxHeight" :small="true" />
                </v-card>
            </v-col>
        </v-row>
        <AuditCheckDocumentDialog
            v-model="shouldAuditCheckDocumentDialogBeVisible"
            :auditChecks="auditCheckDocumentsWithAnomaly"
            :companyId="companyId"
        />
    </v-container>
</template>

<script lang="ts">
import ChatCompany from "./chat/ChatCompany.vue";
import ConnectorStateCard from "./dashboard/ConnectorStateCard.vue";
import { Apollo } from "@/decorators";
import BANK_ACCOUNTS from "@/graphql/bank/BankAccountsWithBTCount.gql";
// import GET_CONNECTORS from "@/graphql/connector/GetConnectors.gql"
import GET_CONNECTORS from "@/graphql/connector/GetCompanyConnectors.gql";
import SettingConnector from "./configuration/settings/SettingConnector.vue";
import { ConnectorServices } from "@/services/connectorServices";
import { User } from "@/store/store";
import OPEN_POINTS from "@/graphql/openPoints/OpenPoints.gql";
import AUDIT_MONITORING from "@/graphql/audit/Monitoring.gql";
import TAXES_MONITORING from "@/graphql/audit/TaxesMonitoring.gql";
import AUDIT_REPORT_MONITORING from "@/graphql/audit/AuditReportMonitoring.gql";
import FILTER_BANK_TRANSACTIONS_SHORT from "@/graphql/bankTransaction/FilterBankTransactionsShort.gql";
import FILTER_DOCUMENTS_SHORT from "@/graphql/document/FilterDocumentsShort.gql";
import { insertIntoCatergory } from "@/services/openPointsServices";

import moment from "moment-timezone";
import { ConnectedBankAccount } from "@/types/bankAccounts.types";
import { AuditCheckDocumentResult } from "@/types/auditCheck.types";

import AccountingClientMonitoringProductionRow from "@/views/accountingClients/AccountingClientMonitoringProductionRow.vue";
import AccountingClientMonitoringTaxesRow from "@/views/accountingClients/AccountingClientMonitoringTaxesRow.vue";
import AccountingClientMonitoringClosureRow from "@/views/accountingClients/AccountingClientMonitoringClosureRow.vue";
import CompanyConnectors from "./configuration/connectors/ConnectorsTable.vue";
import AuditCheckDocumentDialog from "@/views/document/AuditCheckDocumentDialog.vue";
import AuditCheckCard from "@/views/audit/AuditCheckCard.vue";
import AccountingClientMonitoringServices from "@/services/accountingClientMonitoringServices";
import { getAuditCheckDocuments } from "@/services/audit/auditCheckDocument.services";
import { Component, Prop, Vue, toNative, Watch } from "vue-facing-decorator";

@Component({
    components: {
        ChatCompany,
        ConnectorStateCard,
        SettingConnector,
        CompanyConnectors,
        AccountingClientMonitoringProductionRow,
        AccountingClientMonitoringTaxesRow,
        AccountingClientMonitoringClosureRow,
        AuditCheckDocumentDialog,
        AuditCheckCard,
    },
})
export class CompanyStatusBoard extends Vue {
    @Prop({ default: "openPoints" }) mode: any;

    noAccountingPeriodMessage = "Aucune période comptable sélectionnée"; // Message shown when no accounting period is selected

    boxHeightInPx = "max(200px, 100vh - 495px)";
    flowTableHeight = "max(163px, 100vh - 536px)";
    connectorsEmptyMsgBoxHeight = "max(200px, 100vh - 539px)";
    chatMessagesBoxHeight = "max(120px, 100vh - 634px)";

    // companyId = "ck93umltabtuf0730wifcojfb"  // Hardcoded for testing purpose only
    // accountingPeriodId = "clpweci910002h5m494c0tccq"  // Hardcoded for testing purpose only

    upsertConfig: any = "";
    loadingOpenPoints = false;
    loadingAuditCheckDocuments = false;
    loadingConnectors = false;
    loadingConnectedBankAccounts = false;
    loadingProduction = false;
    loadingTaxes = false;
    loadingFinalization = false;
    loadingBankTransactions = false;
    loadingDocuments = false;

    productionOptions = ["EXPENSE", "SALES", "PAY_SLIP", "BANK_TRANSACTION"];
    taxOptions = ["TVA", "IS", "CVAE"];

    shouldAuditCheckDocumentDialogBeVisible = false;

    /**
     * List of audit check document items with anomaly.
     */
    auditCheckDocumentsWithAnomaly: AuditCheckDocumentResult[] = [];

    get companyId() {
        return this.company?.id;
    }

    get startDate() {
        return (
            this.accountingPeriod?.start || moment().add(-11, "months").startOf("month").format()
        ); // Defaults to one year ago
    }

    get endDate() {
        return this.accountingPeriod?.end || moment().endOf("month").format(); // Defaults to now
    }

    get accountingPeriodId() {
        return this.accountingPeriod?.id;
    }

    get hasActiveConnections() {
        return this.activeConnectors?.length > 0 || this.connectedBankAccounts?.length > 0;
    }

    async mounted(): Promise<void> {
        await this.initializeAuditCheckDocumentAnomalyCardAndDialog();
    }

    get auditCheckDocumentsWithAnomalyCount() {
        return this.auditCheckDocumentsWithAnomaly.reduce(
            (acc, checkDocument) => acc + checkDocument.count,
            0,
        );
    }

    get isAuditCheckDocumentAnomalyCardVisible(): boolean {
        return this.auditCheckDocumentsWithAnomalyCount > 0;
    }

    get openPointCardColSize(): number {
        return this.isAuditCheckDocumentAnomalyCardVisible ? 3 : 4;
    }

    getLogo(connectorName) {
        return ConnectorServices.getLogo(connectorName);
    }

    @Apollo({
        query: BANK_ACCOUNTS,
        variables() {
            this.loadingConnectedBankAccounts = true;
            return {
                companyId: this.companyId,
                type: "BANK",
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.bankAccounts?.length > 0) {
                    this.connectedBankAccounts = data.bankAccounts.filter(
                        (account: ConnectedBankAccount) => account.budgetInsightId != null,
                    );
                } else {
                    this.connectedBankAccounts = [];
                }
                this.loadingConnectedBankAccounts = false;
            }
        },
    })
    connectedBankAccounts: readonly ConnectedBankAccount[] = [];

    @Apollo({
        query: GET_CONNECTORS,
        variables() {
            this.loadingConnectors = true;
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                if (data) {
                    this.loadingConnectors = false;
                    this.connectors = data.getCompanyConnectors.connectors;
                } else {
                    this.connectors = [];
                }
            }
        },
    })
    connectors: any[] = [];

    @Apollo({
        query: OPEN_POINTS,
        variables() {
            this.loadingOpenPoints = true;
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                withAccountingChat: this.openPointMode,
                outstanding: this.outStandingType,
                userId: this.currentUser.id,
                onlyGlobalStatus: true,
            };
        },
        // skip() {
        //     return !this.isAuthorized || !this.companyId || !this.accountingPeriodId
        // },
        skip() {
            return !this.companyId || !this.accountingPeriodId;
        },
        fetchPolicy: "network-only",
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.openPoints) {
                    if (!data.openPoints.output.categories) {
                        // hack : result is called twice or three time with the same data
                        const categories = [];
                        for (const auxiliaryBalance of data.openPoints.output.auxiliaryBalances) {
                            auxiliaryBalance.loading = false;
                            auxiliaryBalance.active = false;
                            auxiliaryBalance.activateDetail = false;
                            auxiliaryBalance.showDetail = false;
                            insertIntoCatergory(categories, auxiliaryBalance);
                        }
                        this.openPoints = data.openPoints.output;
                        this.openPoints.categories = categories;
                        // if (this.$route.params.companyName) {
                        //     this.openParamCompany()
                        // }
                    }
                } else {
                    this.openPoints = {};
                }
                this.loadingOpenPoints = false;
            }
        },
    })
    openPoints = null;

    @Apollo({
        query: AUDIT_MONITORING,
        variables() {
            this.loadingProduction = true;
            return {
                companiesId: [this.companyId], // ck93umlw4btvg07301oxunp3l
                startDate: moment(this.startDate).startOf("month").format("YYYY-MM-DD"),
                endDate: moment(this.endDate).endOf("month").format("YYYY-MM-DD"),
                // endDate: moment(this.endDate + "-01").endOf("month").format("YYYY-MM-DD")
                // endDate: this.endDate + "-31"
            };
        },
        debounce: 500,
        skip() {
            return !this.startDate || !this.endDate || !this.company; //|| this.eagerArray.includes('production');
        },
        specificResult({ data, loading, networkStatus }: any) {
            // this.loadingDocument = loading;
            if (!loading) {
                if (data && data.auditMonitoring && data.auditMonitoring.monitoring) {
                    this.productionValues = data.auditMonitoring.monitoring[this.companyId]; // It should contain only one object. We extract it using its id
                } else {
                    this.productionValues = {};
                }
                // this.eagerArray.push('production')
                this.loadingProduction = false;
            }
        },
    })
    productionValues = {};

    @Apollo({
        query: TAXES_MONITORING,
        variables() {
            this.loadingTaxes = true;
            return {
                companiesId: [this.companyId], // ck93umlw4btvg07301oxunp3l
                startDate: moment(this.startDate).startOf("month").format("YYYY-MM-DD"),
                endDate: moment(this.endDate).endOf("month").format("YYYY-MM-DD"),
                // endDate: this.endDate + "-31"
            };
        },
        debounce: 500,
        skip() {
            return !this.startDate || !this.endDate || !this.company; //|| this.eagerArray.includes('taxes');
        },
        specificResult({ data, loading, networkStatus }: any) {
            // this.loadingDocument = loading;
            if (!loading) {
                if (data?.taxesMonitoring?.taxesMonitoring) {
                    this.taxesMonitoring = data.taxesMonitoring.taxesMonitoring[this.companyId]; // It should contain only one object. We extract it using its id
                } else {
                    this.taxesMonitoring = {};
                }
                // this.eagerArray.push('taxes')
                this.loadingTaxes = false;
            }
        },
    })
    taxesMonitoring = {};

    @Apollo({
        query: AUDIT_REPORT_MONITORING,
        variables() {
            this.loadingFinalization = true;
            return {
                companiesId: [this.companyId], // ck93umlw4btvg07301oxunp3l
                startDate: moment(this.startDate).startOf("month").format("YYYY-MM-DD"),
                endDate: moment(this.endDate).endOf("month").format("YYYY-MM-DD"),
                // endDate: this.endDate + "-31"
            };
        },
        debounce: 500,
        skip() {
            return !this.startDate || !this.endDate || !this.company; // || this.eagerArray.includes('finalization');
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDocument = loading;
            if (!loading) {
                if (data?.auditReportMonitoring?.auditReportMonitoring) {
                    this.auditReportMonitoring = JSON.parse(
                        JSON.stringify(data.auditReportMonitoring.auditReportMonitoring),
                    );
                } else {
                    this.auditReportMonitoring = {};
                }
                // this.eagerArray.push('finalization')
                this.loadingFinalization = false;
            }
        },
    })
    auditReportMonitoring = {};

    @Apollo({
        query: FILTER_BANK_TRANSACTIONS_SHORT,
        variables() {
            this.loadingBankTransactions = true;
            return {
                companyId: this.companyId,
                first: 10,
                orderBy: "createdAt_DESC",
                where: {
                    account: {
                        companyId: this.companyId,
                    },
                },
            };
        },
        skip() {
            return !this.company; // || !this.isAuthorized
        },
        specificResult({ data, loading, networkStatus }) {
            if (data && !loading) {
                this.latestBankTransactions = data.bankTransactions.map((tr) => ({
                    ...tr,
                    fCreatedAt: moment(tr.createdAt).format("DD/MM/YYYY"),
                }));
            }
            this.loadingBankTransactions = false;
        },
    })
    latestBankTransactions = [];

    @Apollo({
        query: FILTER_DOCUMENTS_SHORT,
        variables() {
            this.loadingDocuments = true;
            return {
                companyId: this.companyId,
                first: 10,
                orderBy: "createdAt_DESC",
                where: {
                    companyId: this.companyId,
                },
            };
        },
        skip() {
            return !this.company;
        },
        specificResult({ data, loading, networkStatus }) {
            if (data && !loading) {
                this.latestDocuments = data.documents.map((doc) => ({
                    ...doc,
                    fCreatedAt: moment(doc.createdAt).format("DD/MM/YYYY"),
                }));
            }

            this.loadingDocuments = false;
        },
    })
    latestDocuments = [];

    /**
     * Latest bank transactions + Latest documents
     * Truncated to the 10 latest
     */
    get incomingFlow() {
        const flow = [];
        for (const transaction of this.latestBankTransactions) {
            flow.push({
                id: transaction.id,
                flowType: transaction.__typename,
                label: transaction.wordingDisplay || transaction.wordingOriginal,
                createdAt: transaction.createdAt,
                fCreatedAt: transaction.fCreatedAt,
                docType: transaction.account?.name,
            });
        }
        for (const doc of this.latestDocuments) {
            flow.push({
                id: doc.id,
                flowType: doc.__typename,
                label: doc.displayName || doc.name,
                createdAt: doc.createdAt,
                fCreatedAt: doc.fCreatedAt,
                docType: doc.type,
            });
        }
        // Sort flow by createdAt dat
        flow.sort((a, b) => `${b.createdAt}`.localeCompare(`${a.createdAt}`));
        return flow.slice(0, 10);
    }

    get activeConnectors() {
        return this.connectors.filter((connector) => connector.isActive);
    }

    async upsertSetting(configValue) {
        this.upsertConfig = await ConnectorServices.upsertSettingHelper(
            configValue,
            this.companyId,
        );
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get openPointMode() {
        return this.mode === "openPoints";
    }

    get outStandingType() {
        if (this.mode?.startsWith("outstanding")) {
            return this.mode.substring(11)?.toLowerCase();
        }
        return "";
    }

    showItems(check) {
        if (check.show && check.show.pathName) {
            const location: any = {
                name: check.show.pathName,
            };
            if (check.show.params) {
                location.params = check.show.params;
            }
            this.$router.push(location);
        }
    }

    showWaitingBT() {
        const location: any = {
            name: "bank",
            params: {
                resetFilter: true,
                reconciliationStatus: "NOT_JUSTIFIED",
            },
        };

        if (this.accountingPeriod) {
            location.params.startDate = this.accountingPeriod.start;
            location.params.endDate = this.accountingPeriod.end;
        }

        this.$router.push(location);
    }

    get accountingPeriod() {
        return this.$store.state.accountingPeriod.selectedAccountingPeriod
            ? this.$store.state.accountingPeriod.selectedAccountingPeriod
            : null;
    }

    get company() {
        return this.$store.state.selected_company;
    }

    get productionHeaders() {
        return AccountingClientMonitoringServices.getHeaders(
            false,
            "production",
            false,
            this.startDate,
            this.endDate,
        );
    }

    get taxesHeaders() {
        return AccountingClientMonitoringServices.getHeaders(
            false,
            "taxes",
            false,
            this.startDate,
            this.endDate,
        );
    }

    get finalizationHeaders() {
        return AccountingClientMonitoringServices.getHeaders(
            false,
            "finalization",
            false,
            this.startDate,
            this.endDate,
        );
    }

    routeToFlowPage(flowObj) {
        if (flowObj.flowType === "BankTransaction") {
            this.$router.push({
                name: "reconciliation/bankTransaction",
                params: { companyId: this.companyId, bankTransactionId: flowObj.id },
            });
        } else if (flowObj.flowType === "Document") {
            this.$router.push({
                name: "document",
                params: { companyId: this.companyId, id: flowObj.id },
            });
        }
    }

    routeToFilteredDocumentsPage() {
        this.$router.push({ name: "documents", query: { orderBy: "createdAt-desc" } });
    }

    routeToFilteredBanksPage() {
        this.$router.push({ name: "bank", query: { orderBy: "createdAt-desc" } });
    }

    routeToConnectorCreationPage() {
        this.$router.push({
            name: "companyEditionTab",
            params: { companyId: this.companyId, activeTab: "Connectors" },
        });
    }

    // insertIntoCatergory(categories, auxiliaryBalance) {
    //     const aaName3 = auxiliaryBalance.name.substring(0, 3)
    //     let category = categories.find(c => c.name === auxiliaryBalance.name)
    //     if (!category) {
    //         category = {
    //             name: auxiliaryBalance.name,
    //             name3: aaName3,
    //             auxiliaryBalances: []
    //         }
    //         categories.push(category)
    //     }
    //     category.auxiliaryBalances.push(auxiliaryBalance)
    // }

    async initializeAuditCheckDocumentAnomalyCardAndDialog(): Promise<void> {
        this.auditCheckDocumentsWithAnomaly = [];
        this.loadingAuditCheckDocuments = true;
        const checkResults: AuditCheckDocumentResult[] = await getAuditCheckDocuments(
            this.$apollo,
            this.companyId,
            this.accountingPeriodId,
        );
        if (checkResults.length > 0) {
            this.auditCheckDocumentsWithAnomaly = checkResults;
        }
        this.loadingAuditCheckDocuments = false;
    }

    onAuditCheckDocumentAnomalyCardClicked(): void {
        this.shouldAuditCheckDocumentDialogBeVisible = true;
    }

    /**
     * When the selected accounting period or company changes, we need to reinitialize open points and the audit check document data.
     */
    @Watch("companyId")
    @Watch("accountingPeriodId")
    async onChange(): Promise<void> {
        this.openPoints = null;
        await this.initializeAuditCheckDocumentAnomalyCardAndDialog();
    }
}

export default toNative(CompanyStatusBoard);
</script>
<style scoped>
.scrollbar-hidden::-webkit-scrollbar {
    overflow: auto;
    display: none;
    width: 12px;
}

.scrollbar-hidden {
    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.rounded-right {
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
}

.bg-light-red {
    background-color: rgba(240, 128, 128, 0.4);
}

.bg-light-green {
    background-color: rgba(32, 168, 129, 0.664);
}

.text-error {
    color: red !important;
}

.text-muted {
    color: grey !important;
}

.box-border {
    border: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.v-data-table .v-data-table__wrapper::-webkit-scrollbar {
    overflow-x: hidden !important;
    -ms-overflow-style: none !important;
    scrollbar-width: none !important;
}

.sticky-top {
    position: sticky !important;
    top: 0 !important;
    z-index: 2 !important;
}

.bg-white {
    background-color: white !important;
}
</style>
